const NO_WABA_PATTERNS = [
  'no business info found',
  'no business info',
];

export function extractApiErrorMessage(error) {
  const payload = error?.response?.data;
  const nested = payload?.data;

  if (typeof nested?.general_error === 'string' && nested.general_error.trim()) {
    return nested.general_error.trim();
  }

  if (typeof nested === 'string' && nested.trim()) {
    return nested.trim();
  }

  return error?.message || 'Failed to fetch WhatsApp apps';
}

export function isEmptyWabaBusinessError(message = '') {
  const normalized = String(message).trim().toLowerCase();
  return NO_WABA_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function normalizeWabaAppsResponse(raw) {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (raw && Array.isArray(raw.data)) {
    return raw.data;
  }

  return [];
}
